export function getTargetString(target, scale, abb) {
  let targetString = "";
  if (scale === "Number") {
    targetString = getNumberInText(target);
  } else if (scale === "Currency") {
    targetString = getAmountInText(target, abb);
  } else if (scale === "Percentage") {
    targetString = target + "%";
  } else {
    targetString = target + abb;
  }
  return targetString;
}

export function getAmountInText(amount, abb) {
  let currencyType = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: abb || "USD",
  });
  // Nine Zeroes for Billions
  return Math.abs(Number(amount)) >= 1.0e9
    ? currencyType.format(0).split("0")[0] +
        (Math.abs(Number(amount)) / 1.0e9).toFixed(2) +
        "B"
    : // Six Zeroes for Millions
    Math.abs(Number(amount)) >= 1.0e6
    ? currencyType.format(0).split("0")[0] +
      (Math.abs(Number(amount)) / 1.0e6).toFixed(2) +
      "M"
    : currencyType.format(amount);
}

export function getNumberInText(amount) {
  let type = Intl.NumberFormat("en-US");
  // Nine Zeroes for Billions
  return Math.abs(Number(amount)) >= 1.0e9
    ? (Math.abs(Number(amount)) / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(amount)) >= 1.0e6
    ? (Math.abs(Number(amount)) / 1.0e6).toFixed(2) + "M"
    : type.format(amount);
}
